export default __webpack_public_path__ + "static/media/11.13.4fdfaf22.jpg";